export default __webpack_public_path__ + "static/media/wiki.9ebfef08.svg";